export default "__VITE_ASSET__bb2aa6e3__"